
/**
 * @author Félix Proulx <felix.proulx@cossette.com>, Christine Daneau-Pelletier <christine.daneau.pelletier@gmail.com>
 * @description Hub pages, content filtering, pagination animation
 */
export class Locations {

    private $jobCategoriesContainer:HTMLElement = null;
    private $institutionCategoriesContainer:HTMLElement = null;
    private $jobCategoriesCheckboxes:NodeListOf<HTMLInputElement> = null;
    private $institutionCategoriesCheckboxes:NodeListOf<HTMLInputElement> = null;
    private $cardsContainer:HTMLElement = null;
    private $paginationContainer:HTMLElement = null;
    private $circle:HTMLElement = null;
    private $pages:NodeListOf<HTMLElement> = null;
    private $lang:String = "en";
    readonly filterTaxonomies_bind:any = null;
    readonly followCircle_bind:any = null;
    readonly followCircleActive_bind:any = null;
    public gtmTracker:any = null;

    public constructor(tracker) {
        this.$jobCategoriesContainer = document.querySelector('.consignor-type-filters');
        this.$jobCategoriesCheckboxes = this.$jobCategoriesContainer.querySelectorAll('input');
        // this.$institutionCategoriesContainer = document.querySelector('.province-type-filters');
        // this.$institutionCategoriesCheckboxes = this.$institutionCategoriesContainer.querySelectorAll('input');
        this.$cardsContainer = document.querySelector('.locations-results');
        this.$paginationContainer = document.querySelector('.locations-pagination');
        this.$circle = document.querySelector('.locations-pagination .circle');
        this.$pages = document.querySelectorAll('.page-number');
        this.filterTaxonomies_bind = this.filterTaxonomies.bind(this);
        this.followCircle_bind = this.followCircle.bind(this);
        this.followCircleActive_bind = this.followCircleActive.bind(this);
        //this.gtmTracker = tracker;
        this.$lang = window.location.toString().includes("/fr/") ? "fr":"en";
        this.init()
    }

    private init():void {
        // Filter with taxo for jobs
        this.$jobCategoriesCheckboxes.forEach( (input) => {
            input.addEventListener('change', this.filterTaxonomies_bind);
        })
        // this.$institutionCategoriesCheckboxes.forEach( (input) => {
        //     input.addEventListener('change', this.filterTaxonomies_bind);
        // })

        // Animation circle pagination
        this.$pages.forEach(item => {
            item.addEventListener('mouseover', this.followCircle_bind);
            item.addEventListener('focusin', this.followCircle_bind);
            item.addEventListener('mouseout', this.followCircleActive_bind);
            if (item.classList.contains('current')) {
                this.$circle.style.width = item.offsetWidth + 'px';
                this.$circle.style.left = item.offsetLeft + 'px';
            }
        });
    }


    /**
     * Filter taxo in Hub jobs
     */
    private filterTaxonomies():void {
        let job_categories: Array<string> = [];
        let institution_categories: Array<string> = [];
        let $button:HTMLElement = null;
        let queryString:string = '';

        this.$jobCategoriesCheckboxes.forEach( (input) => {
            if (input.checked) {
                $button = input.closest('.btn-filter');
                job_categories.push($button.dataset.value)
            }
        });

        // this.$institutionCategoriesCheckboxes.forEach( (input) => {
        //     if (input.checked) {
        //         $button = input.closest('.btn-filter');
        //         institution_categories.push($button.dataset.value)
        //     }
        // });


        if (job_categories.length > 0 || institution_categories.length > 0) {
            queryString = '?'
            // queryString = queryString+'lg='+this.$lang;
            if ( job_categories.length > 0) {
                queryString = queryString + '&consignors=' + encodeURIComponent(job_categories.toString());
                if ( institution_categories.length > 0) {
                    queryString = queryString+'&'
                }
            }
            if ( institution_categories.length > 0) {
                queryString = queryString + '&provinces=' + encodeURIComponent(institution_categories.toString());
            }

            window.history.replaceState(null, null, queryString);
        } else {
            window.history.replaceState({}, '', location.pathname);
        }

        this.ajaxFetchCards(queryString).then((response) => {
            this.$cardsContainer.innerHTML = response.cards.join('');
            this.$paginationContainer.innerHTML = response.pagination.replace('wp-json/cisssmoapi/locations', 'locations');
            //this.gtmTracker.hubUpdateTracker()
        })
    }

    async ajaxFetchCards(queryString) {

        let response = await fetch(`/wp-json/cisssmoapi/locations${queryString}`, {method: 'GET'})
            .catch(error => console.log('error', error))

        if (response) {
            return response.json();
        }
    }



    /**
     * Animation circle the page number you hover
     * @param e mouse on pagination
     */
    private followCircle(e:any):void {
        let itemWidth:number = e.target.offsetWidth;
        let itemPos:number = e.target.offsetLeft;

        this.$circle.style.width = itemWidth + 'px';
        this.$circle.style.left = itemPos + 'px';
    }

    /**
     * Put the circle back under the current page
     * @param e mouse out of pagination
     */
    private followCircleActive(e:any):void {
        this.$pages.forEach(item => {
            if (item.classList.contains('current')) {
                this.$circle.style.width = item.offsetWidth + 'px';
                this.$circle.style.left = item.offsetLeft + 'px';
            }
        });
    }
}
